module.exports = __webpack_public_path__ + "static/media/jeremy-bishop-102621-unsplash.1268f54f.jpg";